import { ScreenReaderHidden } from '@/components/ScreenReaderHidden'

export const Label = ({ text, id }: { text?: string; id: string }) => {
  if (!text) return null
  return (
    <ScreenReaderHidden as="label" htmlFor={id}>
      {text}
    </ScreenReaderHidden>
  )
}
